import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import { FC, useCallback, useState } from 'react';

type CopyFieldProps = TextFieldProps & {
  value: string;
};

export const CopyField: FC<CopyFieldProps> = (props) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(props.value as string);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  }, [props.value]);

  return (
    <TextField
      {...props}
      slotProps={{
        ...props.slotProps,
        input: {
          ...(typeof props.slotProps?.input === 'object' ? props.slotProps.input : {}),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={handleCopy} edge="end" size="small">
                <ContentCopyIcon fontSize="small" color={copied ? 'success' : 'inherit'} />
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
